var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoImageLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.5703,
    r: 16,
    fill: "#FF9900",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 20.8143V22.5703C14.5 23.3987 15.1716 24.0703 16 24.0703C16.8284 24.0703 17.5 23.3987 17.5 22.5703V20.8143M16 9.07031V9.82031M9.25 16.5703H8.5M11.125 11.6953L10.6749 11.2452M20.875 11.6953L21.3252 11.2452M23.5 16.5703H22.75M20.5 16.5703C20.5 19.0556 18.4853 21.0703 16 21.0703C13.5147 21.0703 11.5 19.0556 11.5 16.5703C11.5 14.085 13.5147 12.0703 16 12.0703C18.4853 12.0703 20.5 14.085 20.5 16.5703Z",
    stroke: "#FF9900",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoImageLight);
export default __webpack_public_path__ + "static/media/info-image-light.3375f8c485e7d623e4c4ac6f64a6a181.svg";
export { ForwardRef as ReactComponent };